<template>
    <v-app-bar
      color="grey lighten-5"
      app
    >
      <v-app-bar-nav-icon 
        v-if="authenticated"
        @click.stop="openNavigation"
      ></v-app-bar-nav-icon>
      
      <v-toolbar-title>
        <router-link
          tag="img"
          src="https://i.imgur.com/mroe3OJ.png"
          width="40px"
          height="40"
          :to="`/${$i18n.locale}/`"
        ></router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <LangSwitcher/>

      <template v-if="!authenticated">
        <LoginGuest/>
        <RegisterGuest/>
      </template>
      
      <template v-else>
        <LogoutUser/>
      </template>
      
    </v-app-bar>
</template>

<script>
import LoginGuest from '@/components/structure/app-bar/guest/login';
import LogoutUser from '@/components/structure/app-bar/user/logout';
import RegisterGuest from '@/components/structure/app-bar/guest/register';
import LangSwitcher from '@/components/structure/app-bar/lang';

import { mapGetters } from 'vuex';
import { mapActions } from 'vuex'

export default {
  name: 'AppBar',

  components: {
    LoginGuest,
    RegisterGuest,
    LangSwitcher,
    LogoutUser
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
  },

  methods: {
    ...mapActions({
      openNavigation: 'navigation/open'
    })
  }
};
</script>
